import React, { useEffect, useState } from 'react'
import { useEditPresaleInfoMutation, useSinglePresaleInfoMutation, useActiveEditPresaleInfoMutation } from './store/ReduxApis';
import { useHistory } from 'react-router-dom';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import toast, { Toaster } from 'react-hot-toast';
import { useParams } from 'react-router-dom'


function EditPresaleRound() {

    // Function to get today's date in 'DD-MM-YYYY' format
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const { id } = useParams();
    const [presalePost, responseInfo1] = useSinglePresaleInfoMutation();
    const [createPost, responseInfo] = useEditPresaleInfoMutation();
    const [activeEdit, responseActiveEditInfo] = useActiveEditPresaleInfoMutation();
    const [presaleTitle, setPresaleTitle] = useState("")
    const [startDate, setStartDate] = useState(getCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDate());
    const [supply, setSupply] = useState("")
    const [price, setPrice] = useState("")
    const [MinAmount, setMinAmount] = useState("")
    const [MaxAmount, setMaxAmount] = useState("")
    const [error, setError] = useState('');
    const [presaleData, setPresaleData] = useState({})
    const [errorValid, setErrorValid] = useState({});


    const history = useHistory();


    const getOneData = async () => {
        const updateUserDetails = await presalePost({ "_id": id })
            .then(res => {
                // setPresaleData(res?.data?.data, "res")
                const data = res?.data?.data;
                setPresaleData(data);
                setStartDate(data?.startDate);
                setEndDate(data?.endDate);
            })
        console.log(updateUserDetails, "details")
    }

    useEffect(() => {
        getOneData();
    }, [])

    // const validateDates = (newStartDate, newEndDate) => {
    //     if (newStartDate === newEndDate) {
    //         setError('Start Date and End Date cannot be the same.');
    //         return false;
    //     } else if (newStartDate > newEndDate) {
    //         setError('End Date should be greater than Start Date.');
    //         return false;
    //     } else {
    //         setError('');
    //         return true;
    //     }
    // };

    const validateDates = (newStartDate, newEndDate) => {
        const errors = {};
        if (!startDate) {
            errors.startDate = "Start Date is required";
        }
        if (!endDate) {
            errors.endDate = "End Date is required";
        }
        if (newStartDate === newEndDate) {
            errors.dateValidation = "Start Date and End Date cannot be the same.";
        }
        else if (newStartDate > newEndDate) {
            errors.dateValidation = "End Date should be greater than Start Date.";
        }

        if (!presaleData?.supply || isNaN(presaleData?.supply)) {
            errors.supply = "Supply should be a number";
        }
        // if (!presaleData?.price || isNaN(presaleData?.price)) {
        //     errors.price = "Price should be a number";
        // }
        if (!presaleData?.priceinusd || isNaN(presaleData?.priceinusd)) {
            errors.priceinusd = "Price in USD should be a number";
        }
        if (!presaleData?.salepercentage || isNaN(presaleData?.salepercentage)) {
            errors.salepercentage = "Sale Percentage should be a number";
        }
        // if (presaleData?.minAmount === "" || isNaN(presaleData?.minAmount)) {
        //     errors.minAmount = "Min Amount should be a number";
        // } else if (parseFloat(presaleData?.minAmount) <= 0) {
        //     errors.minAmount = "Min Amount should be greater than 0";
        // }
        // if (presaleData?.maxAmount === "" || isNaN(presaleData?.maxAmount)) {
        //     errors.maxAmount = "Max Amount should be a number";
        // } else if (parseFloat(presaleData?.minAmount) >= parseFloat(presaleData?.maxAmount)) {
        //     errors.amountValidation = "Maximum amount should be greater than minimum amount";
        // }

        // if (!presaleData?.minAmount || isNaN(presaleData?.minAmount)) {
        //     errors.minAmount = "Min Amount should be a number";
        // }
        // if (!presaleData?.maxAmount || isNaN(presaleData?.maxAmount)) {
        //     errors.maxAmount = "Max Amount should be a number";
        // } 
        // else if (parseFloat(presaleData?.minAmount) <= 0) {
        //     errors.minAmount = "Min Amount should be greater than 0";
        // }
        // if (presaleData?.minAmount && presaleData?.maxAmount && !isNaN(presaleData?.minAmount) && !isNaN(presaleData?.maxAmount)) {
        //     if (parseFloat(presaleData?.minAmount) >= parseFloat(presaleData?.maxAmount)) {
        //         errors.amountValidation = "Maximum amount should be greater than minimum amount";
        //     }
        // }

        setErrorValid(errors);
        return Object.keys(errors).length === 0;
    };


    const handleStartDateChange = (e) => {
        const newStartDate = e.target.value;
        setStartDate(newStartDate);
        validateDates(newStartDate, endDate);
    };

    const handleEndDateChange = (e) => {
        const newEndDate = e.target.value;
        setEndDate(newEndDate);
        validateDates(startDate, newEndDate);
    };

    const newPost = {
        "_id": id,
        "presaleTitle": presaleData?.presaleTitle,
        "startDate": startDate,
        "endDate": endDate,
        "supply": presaleData?.supply,
        // "price": Number(presaleData?.price),
        "priceinusd": Number(presaleData?.priceinusd),
        "salepercentage": presaleData?.salepercentage,
        // "minAmount": presaleData?.minAmount,
        // "maxAmount": presaleData?.maxAmount,
    }

    const EditPresale = async (e) => {
        e.preventDefault();
        if (!validateDates(startDate, endDate)) {
            return;
        }
        console.log("addPresale:", newPost);

        if (presaleData?.hash === "") {
            await createPost(newPost);
        }
        else {
            await activeEdit(newPost)
        }

    }

    useEffect(() => {
        if (responseInfo?.data?.status === "success") {
            toast(responseInfo?.data?.message)
            // setTimeout(() => (window.location.href = '/#/presale'), 2000);
            setTimeout(() => history.push('/presale'), 2000);
        } else if (responseInfo?.error?.data?.status === "fail") {
            toast(responseInfo?.error?.data?.message)
        }
        else if (responseInfo?.status === "fulfilled") {
            toast(responseInfo?.data?.message)
        }

    }, [responseInfo])


    useEffect(() => {
        if (responseActiveEditInfo?.data?.status === "success") {
            toast(responseActiveEditInfo?.data?.message)
            // setTimeout(() => (window.location.href = '/#/presale'), 2000);
            setTimeout(() => history.push('/presale'), 2000);
        } else if (responseActiveEditInfo?.error?.data?.status === "fail") {
            toast(responseActiveEditInfo?.error?.data?.message)
        }
        else if (responseActiveEditInfo?.status === "fulfilled") {
            toast(responseActiveEditInfo?.data?.message)
        }

    }, [responseActiveEditInfo])

    return (
        <div>
            <Toaster />

            <div className="content-wrapper">

                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6 text">
                                <h1>Edit Presale</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Edit Presale</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6 offset-md-2">

                                <div className="card card-outline card-primary">
                                    <form onSubmit={(e) => EditPresale(e)}>
                                        <div className="card-body">

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='presaleTile'> Presale Title </label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Presale Title" 
                                                    name='presaleTitle'
                                                    value={presaleData?.presaleTitle}
                                                    onChange={e => {
                                                        setPresaleData({
                                                            ...presaleData,
                                                            presaleTitle: e.target.value
                                                        })
                                                    }}
                                                    disabled
                                                    required />
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='supply'> Supply </label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Supply" 
                                                    name='supply'
                                                    value={presaleData?.supply}
                                                    onChange={e => {
                                                        setPresaleData({
                                                            ...presaleData,
                                                            supply: e.target.value
                                                        })
                                                    }}
                                                    required />
                                                {errorValid.supply && <p style={{ color: 'red' }}>{errorValid.supply}</p>}
                                            </div>

                                            {/* <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'> Price ( BNB )</label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Price" 
                                                    name='price' required
                                                    onChange={e => {
                                                        setPresaleData({
                                                        ...presaleData,
                                                        price: e.target.value
                                                      })
                                                    }}
                                                    value={presaleData?.price}
                                                     />
                                                      {errorValid.price && <p style={{ color: 'red' }}>{errorValid.price}</p>}
                                            </div> */}

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'> Price ( USD )</label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Price" 
                                                    name='price' required
                                                    onChange={e => {
                                                        setPresaleData({
                                                            ...presaleData,
                                                            priceinusd: e.target.value
                                                        })
                                                    }}
                                                    value={presaleData?.priceinusd}
                                                />
                                                {errorValid.priceinusd && <p style={{ color: 'red' }}>{errorValid.priceinusd}</p>}
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='price'>Sale Percentage</label>
                                                <input type="text" className="addPost"
                                                    // placeholder="Price" 
                                                    name='price' required
                                                    onChange={e => {
                                                        setPresaleData({
                                                            ...presaleData,
                                                            salepercentage: e.target.value
                                                        })
                                                    }}
                                                    value={presaleData?.salepercentage}
                                                />
                                                {errorValid.salepercentage && <p style={{ color: 'red' }}>{errorValid.salepercentage}</p>}
                                            </div>

                                            {/* <div className="mb-3">
                                                <label className='addlabel' htmlFor='MinAmount'> MinAmount </label>
                                                <input type="text"
                                                    className="addPost"
                                                    // placeholder="MinAmount" 
                                                    name='MinAmount'  
                                                    required 
                                                    onChange={e => {
                                                        setPresaleData({
                                                        ...presaleData,
                                                        minAmount: e.target.value
                                                      })
                                                    }}
                                                    value={presaleData?.minAmount}
                                                    // value={presaleData?.MinAmount || '0'}
                                                    />
                                                    {errorValid.minAmount && <p style={{ color: 'red' }}>{errorValid.minAmount}</p>}
                                            </div> */}

                                            {/* <div className="mb-3">
                                                <label className='addlabel' htmlFor='MaxAmount'> MaxAmount </label>
                                                <input type="text" className="addPost"
                                                    // placeholder="MaxAmount" 
                                                    name='MaxAmount' required 
                                                    onChange={e => {
                                                        setPresaleData({
                                                        ...presaleData,
                                                        maxAmount: e.target.value
                                                      })
                                                    }}
                                                    value={presaleData?.maxAmount}
                                                    />
                                                     {errorValid.maxAmount && <p style={{ color: 'red' }}>{errorValid.maxAmount}</p>}
                                                     {errorValid.amountValidation && <p style={{ color: 'red' }}>{errorValid.amountValidation}</p>}
                                            </div> */}

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='startDate'> Start Date </label>
                                                <input type="date" className="addPost"
                                                    // placeholder="Start Date" 
                                                    name='startDate' value={startDate} onChange={handleStartDateChange} required />
                                                {errorValid.startDate && <p style={{ color: 'red' }}>{errorValid.startDate}</p>}
                                            </div>

                                            <div className="mb-3">
                                                <label className='addlabel' htmlFor='endDate'> End Date </label>
                                                <input type="date" className="addPost"
                                                    // placeholder="End Date" 
                                                    name='endDate' value={endDate} onChange={handleEndDateChange} required />
                                                {errorValid.endDate && <p style={{ color: 'red' }}>{errorValid.endDate}</p>}
                                                {errorValid.dateValidation && <p style={{ color: 'red' }}>{errorValid.dateValidation}</p>}
                                            </div>

                                            <button type='submit' className="btnPost">Edit Presale</button>
                                        </div>
                                    </form>

                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </div>
    )
}

export default EditPresaleRound